import get from 'lodash/get';
import find from 'lodash/find';
// FIXME: PLEASE. shared folder needs to be self contained, this creates circular dependency shared <-> routes
import { listingChannelToUrlChannel } from '../../../routes/listingPresenter';

const ForSale = {
  id: 'buy',
  price: 'forSale',
  omniture: 'for sale',
  tealium: 'for sale',
  krux: 'buy',
  url: 'for-sale',
  adArea: 'buy',
  shortHumanReadable: 'Buy',
  displayInSelect: 'Buy',
  humanReadable: 'For Sale',
  titleVariant: 'for Sale',
  title: 'Commercial Real Estate & Commercial Property For Sale and For Lease',
};

const ForLease = {
  id: 'rent',
  price: 'forLease',
  omniture: 'for lease',
  tealium: 'for lease',
  krux: 'lease',
  url: 'for-lease',
  adArea: 'lease',
  shortHumanReadable: 'Lease',
  displayInSelect: 'Lease',
  humanReadable: 'For Lease',
  titleVariant: 'for Lease',
  title: 'Commercial Real Estate & Commercial Property For Lease',
};

const Sold = {
  id: 'sold',
  price: 'sold',
  omniture: 'sold',
  tealium: 'sold',
  krux: 'sold',
  url: 'sold',
  adArea: 'sold',
  shortHumanReadable: 'Sold',
  displayInSelect: 'Sold',
  humanReadable: 'Sold',
  titleVariant: 'Sold',
  title: 'Sold Commercial Property - realcommercial.com.au',
};

const Leased = {
  id: 'leased',
  price: 'leased',
  omniture: 'leased',
  tealium: 'leased',
  krux: 'leased',
  url: 'leased',
  adArea: 'leased',
  shortHumanReadable: 'Leased',
  displayInSelect: 'Leased',
  humanReadable: 'Leased',
  titleVariant: 'Leased',
  title: 'Leased Commercial Property - realcommercial.com.au',
};

const Invest = {
  id: 'invest',
  price: 'invest',
  omniture: 'invest',
  tealium: 'invest',
  krux: 'invest',
  url: 'invest',
  displayInSelect: 'Invest',
  humanReadable: 'Investment',
  shortHumanReadable: 'Invest',
  titleVariant: 'for Investment',
  title: 'Commercial Investment Property - realcommercial.com.au',
};

export const channelObjects = {
  ForSale,
  ForLease,
  Invest,
  Sold,
  Leased,
};

export function queryStringFromChannelObject(channelObject = ForSale) {
  const isForSaleChannel = channelObject.url === ForSale.url;

  return !isForSaleChannel ? channelObject.url : undefined;
}

export function channelFromUrl(urlChannel) {
  return find(channelObjects, ch => ch.url === urlChannel);
}

export function channelIdFromUrl(urlString = '') {
  const channel = channelFromUrl(urlString);
  return channel && channel.id;
}

function ChannelNotFound(channel) {
  this.status = 404;
  this.message = `the channel '${channel}' was not found`;
}

export function parseUrlChannel(urlChannel) {
  const channelObject = channelFromUrl(urlChannel);
  if (channelObject) { return channelObject; }
  throw new ChannelNotFound(urlChannel);
}

// TODO: Remove this function from here in favour of domain specific implmentation
const getPDPChannel = (pageParameters, query) => get(query, 'listingType') || get(pageParameters, 'data.listing.availableChannels[0].id');

export const getCurrentChannel = (pageParameters, query) => {
  if (get(pageParameters, 'data.searchResult')) {
    const urlChannel = pageParameters.channel;
    return urlChannel === 'sold-leased' ? 'sold' : urlChannel;
  } if (getPDPChannel(pageParameters, query)) {
    const pdpChannel = getPDPChannel(pageParameters, query);
    return listingChannelToUrlChannel(pdpChannel);
  } if (pageParameters.channel) {
    return pageParameters.channel;
  }
  return 'for-sale';
};

export const isSoldOrLeased = channelObject => [Sold.id, Leased.id].includes(channelObject.id);
